import React from 'react';
const LAW_BOTTOM_IMG = 'https://drwzpk38qkpfb.cloudfront.net/www.apc360zone.com/preview/uploaded/images/Redesigne%202024/law-bottom.jpeg?opt=w3';
export function EducatingSection() {
  return <section className="py-16 md:py-24 bg-brand-gray-900 border-t border-brand-gray-800" data-id="element-740">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-741">
        <div className="text-center mb-12 md:mb-16 max-w-4xl mx-auto" data-id="element-742">
          <h2 className="text-3xl md:text-5xl font-extrabold text-brand-white uppercase tracking-wider mb-4" data-id="element-743">
            Educating and Training Many of the Best In the Industry
          </h2>
          <div className="w-16 h-0.5 bg-brand-teal mx-auto" data-id="element-744" />
        </div>

        <div className="max-w-4xl mx-auto prose prose-invert prose-lg text-brand-gray-300 leading-relaxed text-center mb-16" data-id="element-745">
          <p data-id="element-746">
            Our training and education programs consistently receive highly
            positive feedback from all participants. Programs such as the Basic
            SWAT High Impact Fundamentals Program have been carefully developed
            and refined to support patrol officers who may not be part of a SWAT
            team, but need to understand the critical dynamics and tactics
            necessary for responding effectively to high-pressure incidents,
            including Active Shooter situations.
          </p>
          <p data-id="element-747">
            Additionally, our workshops, including the Telecommunication
            Operator's Roles During Active Shooter Events and Telecommunications
            Operator's Critical Incident Training, are designed to equip
            dispatchers with the tactical knowledge and skills required to
            operate under stress while addressing the specific needs of first
            responders during critical incidents.
          </p>
        </div>

        <div className="w-full border border-brand-gray-800" data-id="element-748">
          <img src={LAW_BOTTOM_IMG} alt="Tactical Training Group" className="block w-full h-auto object-cover" data-id="element-749" />
        </div>
      </div>
    </section>;
}